import type { NavigationGuard } from 'vue-router'
import { useAccountStore } from '@/stores/account.ts'
import { routeNames } from '@/router/names.ts'
import { useSubAccountStore } from '@/stores/subAccount.ts'
import { routeNamesByDocumentCode } from '@/config/requiredDocumentsCodes.ts'

export const authGuard: NavigationGuard = async (to, from, next) => {
    const accountStore = useAccountStore()
    const subAccountStore = useSubAccountStore()

    const subAccountIdFromRoute = to.params.subAccountId ? String(to.params.subAccountId) : null

    if (
        accountStore.accountData &&
        subAccountStore.subAccountsOptions.length &&
        subAccountIdFromRoute &&
        accountStore.accountData.assignSubaccounts.includes(subAccountIdFromRoute)
    ) {
        return next()
    }

    const { isSuccess: isAccountDataLoadSuccess, documentToAccept: documentToAccept1 } =
        await accountStore.loadAccountData()
    const { isSuccess: isSubAccountsLoadSuccess, documentToAccept: documentToAccept2 } =
        await subAccountStore.loadSubAccountsOptions()

    if (documentToAccept1 || documentToAccept2) {
        const docToAccept = documentToAccept1 || documentToAccept2

        return next({
            name: routeNamesByDocumentCode[docToAccept!],
        })
    }

    if (!isAccountDataLoadSuccess || !isSubAccountsLoadSuccess) {
        accountStore.logout(true)

        return next({
            name: routeNames.LOGIN_VIEW_NAME,
        })
    }

    if (
        subAccountIdFromRoute &&
        accountStore.accountData!.assignSubaccounts.includes(subAccountIdFromRoute)
    ) {
        return next()
    } else {
        const firstSubAccountId = accountStore.accountData!.assignSubaccounts[0]

        return next({
            name: routeNames.HOME_VIEW_NAME,
            params: {
                subAccountId: firstSubAccountId,
            },
        })
    }
}
